import React, { useEffect } from "react";
import AppLayout from "components/Layout/AppLayout";
import AppMenu from "components/Base/AppMenu";
import AppButton from "components/Base/AppButton";

import { useNavigate } from "react-router-dom";
import { whenIsBlessingExpiring, BlessingType} from "services/blessings";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

import FireImg from "assets/images/fire.svg";
import FireActiveImg from "assets/images/fire-active.svg";
import WaterImg from "assets/images/water.svg";
import WaterActiveImg from "assets/images/water-active.svg";
import EarthImg from "assets/images/earth.svg";
import EarthActiveImg from "assets/images/earth-active.svg";
import AirImg from "assets/images/air.svg";
import AirActiveImg from "assets/images/air-active.svg";
import GoImg from "assets/images/go.svg";
import GoActiveImg from "assets/images/go-active.svg";

const blessingMenu = [
  {
    name: "Love",
    type: "love",
  },
  {
    name: "Work",
    type: 'work',
  },
  {
    name: "Health",
    type: 'health',
  },
  {
    name: "Relationships",
    type: 'relationships',
  }
]

const getRandomNumber = () => {
  return (Math.floor(Math.random() * 21) + 1).toString();
}

const charms = [
  {
    name: "Fire",
    type: 'e',
    icon: FireImg,
    iconActive: FireActiveImg,
  },
  {
    name: getRandomNumber(),
    type: 'n',
    icon: undefined,
    iconActive: undefined,
  },
  {
    name: "Water",
    type: 'e',
    icon: WaterImg,
    iconActive: WaterActiveImg,
  },
  {
    name: getRandomNumber(),
    type: 'n',
    icon: undefined,
    iconActive: undefined,
  },
  {
    name: 'GO',
    type: 'go',
    icon: GoImg,
    iconActive: GoActiveImg,
  },
  {
    name: getRandomNumber(),
    type: 'n',
    icon: undefined,
    iconActive: undefined,
  },
  {
    name: "Earth",
    type: 'e',
    icon: EarthImg,
    iconActive: EarthActiveImg,
  },
  {
    name: getRandomNumber(),
    type: 'n',
    icon: undefined,
    iconActive: undefined,
  },
  {
    name: "Air",
    type: 'e',
    icon: AirImg,
    iconActive: AirActiveImg,
  }
]


const Menu = (props: { handleClick: (type: BlessingType) => void }) => {
  return (
    <>
    <p className="text-xl font-semibold leading-10 text-center max-w-[320px] lg:max-w-none">
      Your daily blessing<br/>with a touch of magic.
    </p>
    <div className="max-w-[350px] relative flex flex-col">
      {blessingMenu.map((item, index) => 
        <AppButton
          key={index}
          onClick={() => {
            props.handleClick(item.type as BlessingType);
          }}
          variant="outline"
          className="max-w-[280px] w-full mx-auto  h-[54px] mt-[clamp(5px,4cqh,60px)]"
          hideIcon
        >
          {item.name}
        </AppButton>
      )}
    </div>
    </>
  );
}

const SelectCharmsView = (props: { selected: number[], handleClick: (index: number) => void }) => {
  // make sure at least one element and one number are selected.
  const st = props.selected.map(c => charms[c].type);
  const ready = st.includes('e') && st.includes('n');

  return (
    <>
    <p className="text-xl font-semibold leading-10 text-center max-w-[320px] lg:max-w-none">
    Select at least one of each<br/>elements and numbers.
    </p>
    <div className="max-w-[350px] relative">
      <div className="grid grid-cols-3 grid-rows-3 gap-10 p-6 max-w-md mx-auto">
        {charms.map((item, i) => (
          <button
            key={i}
            aria-label={`button ${i + 1}`}
            onClick={() => props.handleClick(i)}
            className="
              flex items-center justify-center 
              p-1 rounded-xl
            "
            disabled={charms[i].type === 'go' && !ready}
          >
            {(item.type === 'e') &&
            <img className="w-12 h-12" src={props.selected.includes(i) ? item.iconActive : item.icon} alt={item.name} />}
            {item.type === 'n' && <span className={twMerge("w-12 h-12 text-5xl leading-none font-eatingpasta pt-[6px]" , props.selected.includes(i) ? " text-[#DC143C]" : " text-gray-400")}>{item.name}</span>}
            {(item.type === 'go') && 
              <img className="w-12 h-12" src={ready ? item.iconActive : item.icon} alt={item.name} />}
          </button>
        ))}
      </div>
    </div>
    </>
  );
}

const BlessingsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    for (let i = 0; i < charms.length; i++) {
      if(charms[i].type === 'n') 
        charms[i].name = getRandomNumber();
    }
  }, []);

  const [state, setState] = useState<{selectCharms: boolean, type: BlessingType | null, selected: number[]}>({
    selectCharms: false,
    type: null,
    selected: [],});


  const handleClick = async (type: BlessingType) => {
    const expiry = whenIsBlessingExpiring(type);
    if (expiry > 0) {
      navigate(`/recieve-blessing?type=${type}`);
      return;
    }

    setState({selectCharms: true, type, selected: []});
  };

  const onCharmClick = async (index: number) => {
    if(charms[index].type === 'go') {
      const selectedCharms = charms.filter((c, i) => state.selected.includes(i));
      const elements = selectedCharms.filter(c => c.type === 'e').map(c => c.name).join(',');
      const numbers = selectedCharms.filter(c => c.type === 'n').map(c => c.name).join(',');
      navigate(`/recieve-blessing?type=${state.type}&elements=${elements}&numbers=${numbers}`);
    }

    setState({...state, selected: state.selected.includes(index) ? state.selected.filter(i => i !== index) : [...state.selected, index]});
  };

  return (
    <AppLayout>
      <div className="flex flex-col items-center w-full gap-5">
        
        {state.selectCharms ? (
          <SelectCharmsView 
            selected={state.selected}
            handleClick={onCharmClick}
          />
        ) : (
          <Menu handleClick={handleClick} />
        )}
         
      </div>
      <div className="bottom-menu h-fit w-full justify-center flex flex-cols items-center">
        <AppMenu />
      </div>
    </AppLayout>
  );
};

export default BlessingsPage;
